import React, {useEffect, useState} from 'react';

import apiEntryPoint from '../../api/apiSingleton';

export const locationSelectorHoc = Wrapped => props => {
  const [locationList, setLocationList] = useState([]);

  useEffect(() => {
    apiEntryPoint.finance.banksLocation().then(locations => {
      setLocationList(locations);
    }
    ).catch(e => {
      throw new Error(e.message);
    });
  }, []);
  return <Wrapped {...props} listData={locationList} />;

};
